import FileModel from 'component/uploader/model/file'
import Collection from 'collection/collection'

export default Collection.extend({
    model: FileModel,

    getIds() {
        return this.pluck('id').filter(Boolean)
    },
})
